export const questionAnswer = [
  {
    id: 0,
    question: "What is New HealthAssure Service Provider Portal?",
    answer:
      "The New HealthAssure Service Provider Portal is for all our partner diagnostic service providers in which you can save all your centre details at one place and also submit with us to get them verified before we sharing your details with the customer so that the customer can see the correct information of your center for all the HealthAssure appointment booking you will receive.The information is divided in five category your profile details, verification details, Infrastructure details, Staff Details and Payment Details.You have to fill all the categories to fully complete your profile.We keep all your information secure with us, this information helps us to strengthen our partnership and serve the customers better.",
  },
  {
    id: 1,
    question: "How to change my details ?",
    answer:
      "To change any of your centre details click on “Edit Details” now you can start editing the details you want to change, after editing click on save to save your changes.",
  },
  {
    id: 2,
    question: "How to save and verify my details?",
    answer:
      "To save all your details click on “Save Details” and then click on “Submit” to share and  verify your details with us.",
  },
  {
    id: 3,
    question: "How to upload documents and images?",
    answer:
      "To upload documents and images, click on “Upload” and select the file for uploading. The file format allowed are JPG, JPEG, PNG, PDF and the maximum size of the file  is 2 MB.",
  },
  {
    id: 4,
    question: "How to pin your location on Google Map?",
    answer:
      "To pin your location on the Google Map, navigate to Profile Details tab and click on locate on google map, you can search for your location and then select it on the map and pin it, click on save to save the changes.",
  },
  {
    id: 5,
    question: "What to do in case of any other queries?",
    answer:
      "In case of any other queries please call us on our provider support helpline 022-61676600.",
  },
];
